import {BseDto, SeDto} from "../../autogen/bff-api";

export const eventIsLive = (event: BseDto | SeDto): boolean => {
    return event.status === 'Published' || event.status === 'DeadlineHasPassed'
}